module.exports = __webpack_public_path__ + "static/media/dellBoomiLogo.0dee3370.png";